import ExercisesPage from "./ExercisesPage";
import Banner from "./Banner";
import About from "./About";
import Telegram from "./Telegram";
function Home() {
  return (
    <>
      <Banner />
      <ExercisesPage />
      <Telegram />
    </>
  );
}
export default Home;
